import React from 'react';

import { Button, Emphasis } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { SPACE_KEYS } from '../../keys';
import { SpaceAccessRequestStatus } from '../../types';

interface SpaceAccessRequestProps {
    canRequest: boolean;
    requestStatus?: SpaceAccessRequestStatus;
    /** Whether the access request is in progress. */
    isLoading: boolean;
    /** Triggers the membership request. */
    requestAccess: () => void;
}

export const SpaceAccessRequest: React.FC<SpaceAccessRequestProps> = ({
    canRequest,
    requestStatus,
    isLoading,
    requestAccess,
}) => {
    const { translateKey } = useTranslate();

    const isRequestPending = requestStatus === SpaceAccessRequestStatus.pending;

    // canRequest is true when isRequestPending is, so we don't need to include isRequestPending in the conditions
    if (canRequest || isLoading) {
        return (
            <Button emphasis={Emphasis.medium} isDisabled={isRequestPending || isLoading} onClick={requestAccess}>
                {translateKey(isRequestPending ? SPACE_KEYS.ACCESS_REQUEST_PENDING : SPACE_KEYS.ACCESS_REQUEST)}
            </Button>
        );
    }

    return null;
};
